import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-grid",
  "use": "svg-icon-grid-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-grid\"><path d=\"M16.507 17.848H5.633A1.633 1.633 0 014 16.215V5.632C4 4.731 4.731 4 5.633 4h10.874c.902 0 1.633.731 1.633 1.632v10.583c0 .902-.731 1.633-1.633 1.633h0zM11.07 4v13.848V4zM4 10.924h14.14H4z\" stroke=\"#CAD4D8\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol